import React, { useState, useEffect } from "react";
import { getAllCategories } from "../../../utils/api/getAllCategories";
import { useAuthContext } from "../../../context/AuthContext";
import { Skeleton } from "antd";

const Category = ({ selectedCategory, onSelectCategory , onSelectKey = (value) =>{ }}) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setAuthUser } = useAuthContext();

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const categories = await getAllCategories(setAuthUser);
        setCategories(categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [setAuthUser]);

  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    const selectedCategory = categories.find(
      (category) => category.name === selectedValue
    );
    onSelectCategory(selectedCategory ? selectedCategory.name : "");
    onSelectKey(selectedCategory ? selectedCategory._id : "");
  };

  return (
    <div className="text-xs">
      {loading ? (
        <Skeleton.Button block={true} active={true} />
      ) : (
        <select
          id="category"
          className="p-2 border rounded-md  focus:outline-none focus:ring-0"
          value={selectedCategory}
          onChange={handleCategoryChange}
        >
          <option value="" disabled>
            Select the Category
          </option>
          {categories.map((category) => (
            <option key={category._id} value={category.name}>
              {category.name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default Category;
